import React, { useContext, useRef, useState } from 'react';
import debounce from 'debounce';

import TextField from '@material-ui/core/TextField';

import CityList from './CityList';
import FireDataContext from '../../../services/firebase/FireDataContext';

const CityPicker = ({ onChange, address, label = "Search for a place name", classes = '' }) => {
    const db = useContext(FireDataContext);
    const placeRef = useRef(address);
    const [matches, setMatches] = useState([]);

    const handleChange = debounce(() => {
        (async () => {
            if (!placeRef.current.value) {
                setMatches([]);
                return;
            }

            // title case the input as firebase doesn't seem to support case insensitive search
            const query = placeRef.current.value.replace(/\w+/g,
                (w) => {return w[0].toUpperCase() + w.slice(1).toLowerCase();});

            const places = await db.places({
                name: query,
                size: 10,
            }) || [];

            // console.log('🔥', places.filter(p => /[À-ž]/.test(p.name)).map(p => p.name));

            setMatches(places);
        })();    

    }, 500);

    const handleSelect = city => {
        // setCriteria(city.name);
        setMatches([]);
        placeRef.current.value = '';
        onChange(city);
    }

    return <React.Fragment>
        <TextField
            inputRef={placeRef}
            defaultValue={''}
            onChange={handleChange}
            className={classes}
            variant="outlined"
            label={label}
        />
        <CityList cities={matches} onSelect={handleSelect} />
    </React.Fragment>

};

export default CityPicker;